import { getEnv } from 'mobx-easy';
import { RootEnv } from '../../helpers/create-store';
// @ts-ignore
import { Component, h } from 'preact';

class ErrorBoundary extends Component<{}> {
	componentDidCatch(error, info) {
		getEnv<RootEnv>().airbrakeService.notify({
			error: error,
			params: { info: info },
			context: {}
		});
	}

	render() {
		return this.props.children;
	}
}

export default ErrorBoundary;
